module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', {
    attrs: {
      "id": "unit-info"
    }
  }, [_c('transition', {
    attrs: {
      "name": "up-down",
      "mode": "out-in"
    }
  }, [(_vm.hasInfo) ? _c('div', [(_vm.unit && _vm.unit.description) ? _c('program-information') : _vm._e(), _vm._v(" "), (_vm.unit.cip_code) ? _c('career-opportunities', {
    attrs: {
      "cip": _vm.unit.cip_code
    }
  }) : _vm._e(), _vm._v(" "), (_vm.unit && _vm.unit.point_of_contact) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.unit && _vm.unit.point_of_contact) ? _c('contact-information') : _vm._e()], 1) : _c('div', [_vm._v("\n      No additional program information.\n    ")])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce0eb150","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UnitInfo.vue
// module id = 1138
// module chunks = 1